import { createStore } from 'vuex'
import LocalStorageService from '../services/LocalStorageService'
import ApiService from '@/services/ApiService'
import translations from '@/store/translations'
import DateService from '@/services/DateService'
import router from '@/router/index.js'

export default createStore({
  state: {
    isAdult: false,
    cookies: false,
    videoId: null,
    loading: false,
    idContest: null,
    codeLang: 'ES',
    codeLangs: [
      'ES',
      'CA',
      'EU'
    ],
    config: {
      brand_color: '#000000',
      star_color: '#000000',
      logo_url: ''
    },
    contestData: {},
    translations: {},
    translationsAPI: {},
    filterOptions: [
      { id: '1', type: 'mostVoted', ES: 'Vídeos con más likes', CA: 'Vídeos amb més likes', EU: 'Like gehien duten bideoak' },
      { id: '2', type: 'lessVoted', ES: 'Vídeos con menos likes', CA: 'Vídeos amb menys likes', EU: 'Like gutxien duten bideoak' },
      { id: '3', type: 'mostRecent', ES: 'Vídeos más recientes', CA: 'Vídeos més recents', EU: 'Bideo berrienak' }
    ],
    participations: [],
    participationId: null,
    participationsFiltered: [],
    participationsPaginated: [],
    filter: { id: '3', type: 'mostRecent', ES: 'Vídeos más recientes', CA: 'Vídeos més recents', EU: 'Bideo berrienak' },
    filterWord: null,
    currentPage: 1,
    perPage: 8,
    acceptLegal: false,
    email: null,
    token: null
  },
  mutations: {
    setIsAdult (state, value) {
      state.isAdult = value
    },
    setCookies (state, value) {
      state.cookies = value
    },
    setVideoId (state, value) {
      state.videoId = value
    },
    changeLoading (state, value) {
      state.loading = value
    },
    setIdContest (state, value) {
      state.idContest = value
    },
    setCodeLangs (state, value) {
      state.codeLangs = value
    },
    setConfig (state, value) {
      state.config = value
    },
    changeLang (state, lang) {
      state.codeLang = lang
    },
    setTranslations (state, value) {
      state.translations = value
    },
    setTranslationsAPI (state, value) {
      state.translationsAPI = value
    },
    setPaticipations (state, value) {
      state.participations = value
    },
    setPaticipationId (state, value) {
      state.participationId = value
    },
    setCurrentPage (state, page) {
      state.currentPage = page
    },
    changeFilter (state, value) {
      state.filter = value
    },
    changeFilterWord (state, value) {
      state.filterWord = value
    },
    getParticipationsFiltered (state) {
      const arrayParticipationsFiltered = this.state.participations.sort((a, b) => {
        if (this.state.filter.id === '1') {
          // Most voted
          return b.cms_votes.length - a.cms_votes.length
        } else if (this.state.filter.id === '2') {
          // Less voted
          return a.cms_votes.length - b.cms_votes.length
        } else if (this.state.filter.id === '3') {
          // Most recent
          return DateService.getNewDate(b.cms_createdAt) - DateService.getNewDate(a.cms_createdAt)
        }
      })
      state.participationsFiltered = arrayParticipationsFiltered
    },
    getParticipationsPaginated (state, filtered) {
      const index = (state.currentPage * state.perPage) - state.perPage
      if (filtered) {
        if (state.currentPage !== 1) {
          state.participationsPaginated = state.participationsFiltered.slice(index, state.currentPage * state.perPage)
        } else {
          state.participationsPaginated = state.participationsFiltered.slice(0, state.currentPage * state.perPage)
        }
      } else {
        state.participationsPaginated = state.participationsFiltered.slice(index, state.currentPage * state.perPage)
      }
    },
    setPromotionByName (state) {
      this.commit('changeLoading', true)
      let arrayParticipationsFiltered = this.state.participations
      if (this.state.filterWord !== null) {
        arrayParticipationsFiltered = arrayParticipationsFiltered.filter(element => element.cms_establishment_name === this.state.filterWord)
      }
      state.participationsFiltered = arrayParticipationsFiltered
      this.commit('changeLoading', false)
    },
    setLegal (state, value) {
      state.acceptLegal = value
    },
    setEmail (state, value) {
      state.email = value
    },
    setToken (state, value) {
      state.token = value
    }
  },
  actions: {
    getSession (context) {
      if (LocalStorageService.getParsed('session')) {
        context.commit('setEmail', LocalStorageService.getParsed('session').userEmail)
        context.commit('setToken', LocalStorageService.getParsed('session').token)
      }
    },
    async getParticipations (context, params) {
      context.commit('changeLoading', true)
      try {
        const response = await ApiService.getAPIParticipantsData(params)
        const responseData = response.data.data
        if (response.data.code === 200) {
          context.commit('setCodeLangs', responseData.code_langs)
          context.commit('setConfig', responseData.template_config)
          context.commit('setTranslationsAPI', responseData.cms_translation)
          document.documentElement.style.setProperty('--primary', responseData.template_config.brand_color)
          document.documentElement.style.setProperty('--star', responseData.template_config.star_color)
          context.commit('setIdContest', responseData.id)
          context.commit('setPaticipations', responseData.participations)
          context.commit('getParticipationsFiltered')
          context.commit('getParticipationsPaginated', true)
          context.commit('changeLoading', false)
        } else {
          router.push({ path: '/' })
          context.commit('changeLoading', false)
        }
      } catch (error) {
        router.push({ path: '/' })
        context.commit('changeLoading', false)
      }
    },
    async getParticipation (context, params) {
      context.commit('changeLoading', true)
      try {
        const response = await ApiService.getParticipationId(params)
        const responseData = response.data.data
        if (response.data.code === 200) {
          context.commit('setCodeLangs', responseData.code_langs)
          context.commit('setConfig', responseData.template_config)
          context.commit('setTranslationsAPI', responseData.cms_translation)
          document.documentElement.style.setProperty('--primary', responseData.template_config.brand_color)
          document.documentElement.style.setProperty('--star', responseData.template_config.star_color)
          context.commit('setIdContest', responseData.id)
          context.commit('setPaticipationId', responseData.participation)
          context.commit('changeLoading', false)
        } else {
          router.push({ path: '/' })
          context.commit('changeLoading', false)
        }
      } catch (error) {
        router.push({ path: '/' })
        context.commit('changeLoading', false)
      }
    },
    async getChangeLanguages (context, codeLang) {
      context.commit('changeLang', codeLang)
      DateService.changeLocale(this.state.codeLang.toLowerCase())
      const translationsResult = translations.getTranslations(this.state.codeLang)
      context.commit('setTranslations', translationsResult)
    }
  },
  modules: {
  },
  getters: {
    getIsAdult (state) {
      return state.isAdult
    },
    getTranslationsAPI (state) {
      return state.translationsAPI[state.codeLang]
    },
    getGrade (state) {
      return Number(state.config.beer_grade)
    },
    getLogo (state) {
      return state.config.logo_url
    },
    getLogoAlt (state) {
      return state.config.logo_alt_text
    },
    getPrimary (state) {
      return state.config.brand_color
    },
    getCookies (state) {
      return state.cookies
    },
    isLogged (state) {
      console.log('isLogged email:  ', state.email, ' - token: ', state.token)
      return state.email && state.token
    },
    getCookiesAdviseTrans (state) {
      return state.translations.COOKIES?.cookiesAdvise
    },
    getCookiesModalTrans (state) {
      return state.translations.COOKIES?.cookiesModal
    },
    getPrehomeTrans (state) {
      return state.translations.PREHOME
    },
    getHomeTrans (state) {
      return state.translations.HOME
    },
    getVideolistTrans (state) {
      return state.translations.VIDEOLIST
    },
    getFilterTrans (state) {
      return state.translations.FILTER
    },
    getLoginModalTrans (state) {
      return state.translations.LOGIN_MODAL
    },
    getVoteTrans (state) {
      return state.translations.VOTE
    },
    getCheckLegalTrans (state) {
      return state.translations.CHECK_LEGAL
    },
    getFooterTrans (state) {
      return state.translations.FOOTER
    },
    getCookiesPolicy (state) {
      return state.translations.COOKIES_POLICY
    },
    getLegalAdvise (state) {
      return state.translations.LEGAL_ADVISE
    },
    getPrivacyPolicy (state) {
      return state.translations.PRIVACY_POLICY
    },
    getNotFound (state) {
      return state.translations.NOT_FOUND
    }
  }
})
